
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-39f3c780&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Company.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./Company.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-39f3c780!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Company.vue"),
  /* scopeId */
  "data-v-39f3c780",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Company/Company.vue
// module id = 571
// module chunks = 0